import TextArea from 'antd/es/input/TextArea'
import R from 'app/assets/R'
import { CODE_REGEX } from 'app/common/constants'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { useTranslation } from 'react-i18next'

export const HookFormCommon = () => {
  const { t } = useTranslation()

  return (
    <BaseSpace size={5}>
      <BaseForm.Item
        name={'name'}
        required
        label={'Tên học vị'}
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: 'Tên học vị',
            }),
          },
        ]}
      >
        <BaseInput placeholder={'Nhập tên học vị'} />
      </BaseForm.Item>
      <BaseForm.Item
        name={'code'}
        required
        label={'Mã học vị'}
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: 'Mã học vị',
            }),
          },
          {
            pattern: CODE_REGEX,
            message: "Mã học vị sai định dạng, ex: THAC-SI, KS_01"
          }
        ]}
      >
        <BaseInput placeholder="Nhập mã học vị" />
      </BaseForm.Item>
      <BaseForm.Item name={'descriptions'} label={t(R.strings.description)}>
        <TextArea placeholder="Nhập mô tả" />
      </BaseForm.Item>
    </BaseSpace>
  )
}
